import { completeLinkDialog, fillLinkDialog, selectChoice } from "#/admin/legacy/page-builder/link-dialog.js";
import "#legacy/admin/page_builder/link_dialog/internal_anchors.js";
import "#legacy/admin/page_builder/link_dialog/internal_link.js";
import "#legacy/admin/page_builder/link_dialog/external_link.js";

class LinkDialogInterface {
  constructor(initialValue, callback) {
    this.template = "link-dialog";
    this.el = jQuery(Sparkle.HandlebarsTemplates["link-dialog"]());
    this.modal = new Sparkle.PageBuilder.Modal.Base();
    this.internalAnchors = new InternalAnchors(this.el.find("[name=inpage-anchor]"));
    this.internalLink = new InternalLink(
      this.el[0].querySelector(".admin-search"),
      this.el[0].querySelector("#link-anchor"),
    );
    this.externalLink = new ExternalLink();
    this.setupModal(initialValue);
    this.setupInternalLinkSelector();
    this.setupExternalLinkSelector();
    this.setupAppearanceOptions();

    // BEHAVIOUR

    this.modal.modal.container.on("beforeComplete", this.handleModalComplete.bind(this));
    this.el.find(".tab-selectors input").on("change", this.handleTargetSelectorChange.bind(this));

    this.modal.waitForChoices(this.setValue(initialValue));
    this.setCallback(callback);
  }

  // EVENTS

  handleModalComplete() {
    if (!completeLinkDialog(this)) {
      this.modal.modal.abortCompletion();
    }
  }

  handleTargetSelectorChange() {
    let internalTarget = jQuery(this.el).find(".link-dialog-link-target-internal");
    let target = jQuery(this.el).find(".link-dialog-link-target");
    if (this.el.find("input[value='tab_link-internal']").prop("checked")) {
      internalTarget.show();
      target.hide();
    } else {
      internalTarget.hide();
      target.show();
    }
  }

  // HELPERS

  addRemoveButton(callback) {
    let removeButton = jQuery('<a class="link-dialog-link-remove">Remove link</a>');
    this.modal.modal.getPage(1).nav.find(".nav").prepend(removeButton);
    removeButton.click(callback);
  }

  // PRIVATE

  // Setups

  setupModal(initialValue) {
    this.modal.setContent(this.el);
    this.modal.show();
    initialValue.url ? this.modal.setTitle("Edit Link") : this.modal.setTitle("Insert Link");
  }

  setupInternalLinkSelector() {
    this.el.find("#link-search").append(this.internalLink.previewEl);
    new AdminSearch("#link-dialog-search", { selectCallback: this.internalLink.update.bind(this.internalLink) });
    this.internalLink.hideDisabledModals();
  }

  setupExternalLinkSelector() {
    this.el.find("#tab_link-external_content").append(this.externalLink.input);
  }

  setupAppearanceOptions() {
    this.el.find("#link-title").focus();
  }

  /**
   * Resolves to true once the selects hold `value` and a saved internal link has restored,
   * or undefined if a select fails to mount.
   */
  async setValue(value) {
    this.selectsReady = await fillLinkDialog(this.el[0], value, {
      setTarget: (target) => this.setTarget(target),
      setURL: (url) => this.setURL(url),
    });

    return this.selectsReady;
  }

  setSelectValue(selector, value) {
    selectChoice(this.el[0].querySelector(selector), value);
  }

  getValue() {
    let titleSettings = this.getTitleSettings();
    return {
      title: titleSettings.title,
      documentTitle: titleSettings.documentTitle,
      style: this.el.find(".link-dialog-link-style-select").val(),
      behaviour: this.el.find(".link-dialog-link-behaviour-select").val(),
      url: this.getURL(),
      target: this.getTarget(),
    };
  }

  setTarget(target) {
    var notInternalTarget = target;
    if (target == "lightbox") {
      notInternalTarget = "";
    }
    this.setSelectValue("#link-target-internal-select", target);
    this.setSelectValue("#link-target-select", notInternalTarget);
  }

  getTarget() {
    if (this.el.find(".tab-selectors input[value='tab_link-internal']").prop("checked")) {
      return this.el.find("#link-target-internal-select").val();
    } else {
      return this.el.find("#link-target-select").val();
    }
  }

  getTitleSettings() {
    let dialogTitleInput = this.el.find(".link-dialog-title").val();
    let title = dialogTitleInput;
    let url = this.getURL();

    // If title does not have value then replace with default
    if (!title) {
      if (url.startsWith("#")) {
        title = this.internalAnchors.defaultTitle;
      } else if (url.startsWith("sparkle:")) {
        title = this.internalLink.defaultTitle;
      } else if (url) {
        title = this.externalLink.defaultTitle;
      }
    }

    return { title: title, documentTitle: !dialogTitleInput };
  }

  setURL(url) {
    if (!url) {
      return;
    }
    if (url.startsWith("#")) {
      this.el.find(".tab-selectors input[value='tab_link-inpage']").prop("checked", true).trigger("change");
      this.internalAnchors.value = url;
    } else if (url.startsWith("sparkle:")) {
      this.el.find(".tab-selectors input[value='tab_link-internal']").prop("checked", true).trigger("change");
      return this.internalLink.update(url);
    } else if (url) {
      this.externalLink.value = url;
      this.el.find(".tab-selectors input[value='tab_link-external']").prop("checked", true).trigger("change");
    }
  }

  getURL() {
    var url = "";
    var type = this.el.find(".tab-selectors input:checked").val();
    if (type == "tab_link-inpage") {
      url = "#" + this.internalAnchors.value;
    } else if (type == "tab_link-internal") {
      url = this.internalLink.value;
    } else if (type == "tab_link-external") {
      url = this.externalLink.value;
    }
    return url ? url : "";
  }

  setCallback(callback) {
    this.callback = callback;
  }
}

window.LinkDialogInterface = LinkDialogInterface;
